import React, { useState } from 'react';
import { UserCheck } from 'lucide-react';
import { API_ENDPOINTS } from '../../config/api';
import { t } from '../../i18n/languages';

const YearEndModal = ({
  show,
  currentLanguage,
  setShow,
  setError,
  setLoading,
  yearStatus
}) => {
  const [isSuccess, setIsSuccess] = useState(false);
  if (!show) return null;

  const year = yearStatus?.currentOpenYear;

  const handleClose = () => {
    setShow(false);
    setError('');
  };

  const handleConfirm = async () => {
    try {
      setLoading(true);
      const response = await fetch(API_ENDPOINTS.CLOSE_YEAR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ year }),
      });

      if (response.ok) {
        setIsSuccess(true);
      } else {
        const errorData = await response.json();
        setError(errorData.error || 'Failed to close year');
      }
    } catch (err) {
      setError('Error closing year: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <div style={headerStyle}>
          <div style={iconWrapperStyle}>
            <UserCheck size={24} color="#059669" />
          </div>
          <h3 style={titleStyle}>
            {t('closeYear', { year }, currentLanguage)}
          </h3>
        </div>

        <p style={textStyle}>
          {isSuccess ? (
            t('yearClosedSuccessfully', {}, currentLanguage)
          )
            :
            (
              <p style={textStyle}>
                {t('closeYearWarning', { year }, currentLanguage)}
              </p>
            )
          }</p>

        <div style={buttonWrapperStyle}>
          {isSuccess ? (
            <button
              onClick={handleClose}
              style={confirmBtnStyle}
              onMouseOver={(e) => e.target.style.backgroundColor = '#047857'}
              onMouseOut={(e) => e.target.style.backgroundColor = '#059669'}
            >
              {t('close', {}, currentLanguage)}
            </button>
          ) : (
            <>
              <button
                onClick={handleClose}
                style={cancelBtnStyle}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = '#f3f4f6';
                  e.target.style.color = '#374151';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#6b7280';
                }}
              >
                {t('cancel', {}, currentLanguage)}
              </button>

              <button
                onClick={handleConfirm}
                style={confirmBtnStyle}
                onMouseOver={(e) => e.target.style.backgroundColor = '#047857'}
                onMouseOut={(e) => e.target.style.backgroundColor = '#059669'}
              >
                {t('closeYear', { year }, currentLanguage)}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default YearEndModal;

// Styles

const overlayStyle = {
  position: 'fixed',
  top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000
};

const modalStyle = {
  backgroundColor: 'white',
  borderRadius: '12px',
  padding: '24px',
  maxWidth: '500px',
  width: '90%',
  boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
};

const headerStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  marginBottom: '16px'
};

const iconWrapperStyle = {
  width: '48px',
  height: '48px',
  borderRadius: '50%',
  backgroundColor: '#ecfdf5',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

const titleStyle = {
  margin: 0,
  fontSize: '18px',
  fontWeight: '600',
  color: '#1f2937'
};

const textStyle = {
  margin: '0 0 24px 0',
  fontSize: '14px',
  color: '#6b7280',
  lineHeight: '1.5'
};

const buttonWrapperStyle = {
  display: 'flex',
  gap: '12px',
  justifyContent: 'flex-end'
};

const cancelBtnStyle = {
  padding: '10px 20px',
  backgroundColor: 'transparent',
  color: '#6b7280',
  border: '1px solid #d1d5db',
  borderRadius: '8px',
  fontSize: '14px',
  fontWeight: '500',
  cursor: 'pointer',
  transition: 'all 0.2s'
};

const confirmBtnStyle = {
  padding: '10px 20px',
  backgroundColor: '#059669',
  color: 'white',
  border: 'none',
  borderRadius: '8px',
  fontSize: '14px',
  fontWeight: '500',
  cursor: 'pointer',
  transition: 'background-color 0.2s'
};
